import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * Custom hook to load and manage dashboard preferences
 * @returns {Object} Dashboard preferences and loading state
 */
const useDashboardPreferences = () => {
  const [preferences, setPreferences] = useState({
    stats_cards_visible: true,
    welcome_section_visible: true,
    quick_actions_visible: true,
    role_specific_sections: {}
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPreferences();

    // Listen for preference updates from SystemSettingsModal
    const handlePreferencesUpdate = (event) => {
      console.log("Dashboard received preferences update:", event.detail);
      setPreferences(event.detail);
    };
    
    window.addEventListener('dashboardPreferencesUpdated', handlePreferencesUpdate);
    
    // Cleanup
    return () => {
      window.removeEventListener('dashboardPreferencesUpdated', handlePreferencesUpdate);
    };
  }, []);

  const loadPreferences = async () => {
    setLoading(true);
    try {
      // Try to load from API
      const response = await api.get('/dashboard/dashboard-preferences');
      console.log("Loaded dashboard preferences from API:", response.data);
      setPreferences(response.data);
    } catch (error) {
      console.error('Error loading dashboard preferences:', error);
      
      // Try to load from localStorage as fallback
      const storedPrefs = localStorage.getItem('dashboard_preferences');
      if (storedPrefs) {
        try {
          const parsedPrefs = JSON.parse(storedPrefs);
          console.log("Loaded dashboard preferences from localStorage:", parsedPrefs);
          setPreferences(parsedPrefs);
        } catch (e) {
          console.error('Error parsing stored preferences:', e);
          // Keep defaults if localStorage parse fails
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return { preferences, loading };
};

export default useDashboardPreferences;